<template>
  <svg 
    xmlns="http://www.w3.org/2000/svg" 
    :width='width'
    :height='height'
    viewBox="0 0 24 24"
  >
    <g id="Group_4" data-name="Group 4" transform="translate(-755 -1245)">
      <g id="Group_2" data-name="Group 2" transform="translate(0 86)">
        <g id="Ellipse_1" data-name="Ellipse 1" transform="translate(755 1159)" fill="#ecdf96" stroke="#323736" stroke-width="1">
          <circle cx="12" cy="12" r="12" stroke="none"/>
          <circle cx="12" cy="12" r="11.5" fill="none"/>
        </g>
      </g>
      <g id="iconfinder_51_171470" transform="translate(759 1249)">
        <path id="Path_7" data-name="Path 7" d="M2.461,7.3H.615a.613.613,0,1,0,0,1.226H2.461a.613.613,0,1,0,0-1.226m1.808,2.75A4.3,4.3,0,1,0,5.845,4.191a4.314,4.314,0,0,0-1.576,5.863M3.5,4.635l-1.6-.92a.614.614,0,1,0-.615,1.062l1.6.92A.614.614,0,1,0,3.5,4.635M5.763,2.822,4.84,1.229a.615.615,0,0,0-1.066.613L4.7,3.435a.615.615,0,0,0,1.066-.613M8.742.613a.615.615,0,0,0-1.23,0V2.453a.615.615,0,0,0,1.23,0V.613Zm3.327.515a.617.617,0,0,0-.841.224l-.922,1.593a.615.615,0,0,0,1.065.613l.923-1.593a.612.612,0,0,0-.225-.838m1.042,4.555,1.6-.92A.615.615,0,0,0,14.092,3.7l-1.6.92a.613.613,0,0,0-.226.838.606.606,0,0,0,.163.183.616.616,0,0,0,.679.043m.429,2.834h1.845a.613.613,0,1,0,0-1.226H13.54a.613.613,0,1,0,0,1.226m-1.049,2.69,1.6.92a.614.614,0,1,0,.615-1.062l-1.6-.92a.614.614,0,1,0-.615,1.062m-2.257,1.786.923,1.593a.615.615,0,0,0,1.066-.613L11.3,12.381a.615.615,0,0,0-1.066.613M7.515,15.339a.615.615,0,0,0,1.23,0V13.5a.615.615,0,0,0-1.23,0ZM4.07,14.944a.616.616,0,0,0,.84-.224l.922-1.593a.615.615,0,0,0-1.066-.613l-.923,1.593a.612.612,0,0,0,.226.838M1.077,11.9a.616.616,0,0,0,.84.224l1.6-.92A.616.616,0,0,0,2.9,10.141l-1.6.92a.613.613,0,0,0-.3.61.623.623,0,0,0,.079.233" fill="#9f3333"/>
      </g>
    </g>
  </svg>
</template>

<script>
export default {
  name: 'IconLightMode',

  props: {
    width: {
      type: Number,
      required: false,
      default: 23.25,
    },

    height: {
      type: Number,
      required: false,
      default: 23.25,
    }
  }
}
</script>
